// Module
var code = "<div layout=\"column\"> <a ng-if=\"$ctrl.podsCount\" class=\"br-link-1 text-ellipsis\" ng-click=\"$ctrl.onClick({fulfillmentSteps:$ctrl.fulfillmentSteps,event:$event}); $event.stopPropagation();\"> {{$ctrl.podsCount === 1 ? 'X_POD_IMAGE' : 'X_POD_IMAGES' | translate: {sum: $ctrl.podsCount || 0} }} </a> </div> ";
// Exports
export default code;